<svelte:options customElement={{
  tag: "biz-page-header",
  shadow:"none",
  props: {
    title: { type: "String" }
  }
}} />

<script>
  import { onMount } from 'svelte';
  import { bizBreakpoint } from "@util/constant";
  let {
    title = "",
  } = $props();

  let isMobile = $state(false);

  onMount(() => {
    const checkWidth = () => {
      isMobile = window.innerWidth <= bizBreakpoint;
    };

    // 初期表示時に幅をチェック
    checkWidth();

    // ウィンドウサイズが変更されたときに幅をチェック
    window.addEventListener('resize', checkWidth);

    // コンポーネントが破棄されるときにイベントリスナーを削除
    return () => {
      window.removeEventListener('resize', checkWidth);
    };
  });
</script>

<div>
  {#if isMobile}
    <!-- SP: 汎用PageHeader CE使用 -->
    <page-header text={title} single></page-header>
  {:else}
    <section class="owd-biz-page-header">
      <h1 class="owd-heading:08">{@html title}</h1>
    </section>
  {/if}
</div>

<style lang="scss">
  .owd-biz-page-header{
    width: 100%;
    padding: 114px 120px;
    margin-bottom: 144px;
    background-color: var(--light-gray);
  }
</style>
